<div *ngIf="example"
     class="item-box pointer">

  <div class="item-head-box">
    <div class="example-text"
         [innerHTML]="example.example_t | rmSlash | resize | keepHtml"></div>
    <div class="item-option-box">
      <app-example-play-btn [example]="example"
                            [manualPlay]="manualPlay"
                            (play)="play.emit($event)"></app-example-play-btn>
    </div>
  </div>

  <div *ngIf="example.word1"
       class="detail-info-box">
    <div class="info-item-box">
      <div class="subject-box">
        <div class="border-box">단어</div>
      </div>
      <div class="con-box">
        <div class="word-list">
          <app-link-content class="word-box"
                            [content]="example.word1.word1 | rmSlash | resize">
          </app-link-content>
          <app-link-content *ngIf="example.word2"
                            class="word-box"
                            [content]="example.word2.word1 | rmSlash | resize">
          </app-link-content>
        </div>
      </div>
    </div>
  </div>

</div>
